import { apiClient } from "@/services/HttpService";

// 登录
export function login(params) {
  return apiClient.post(`/login`, params);
}

export function registerUser(params) {
  return apiClient.post(`/register`, params);
}
